/**
 * Procedure Categories and Procedures for M.Ch. in Hepato Pancreato Biliary (HPB) Surgery students
 * Extracted with strict evidence from official NMC PDF (Page 6-9: "Psychomotor Domain - perform independently")
 */
export const HPB_SURGERY_PROCEDURES = {
  "Hepatic Resection, Shunt & Liver Surgery Procedures": [
    "Anatomical & Non-Anatomical Liver Resection (Segmentectomy, Lobectomy, Extended Hepatectomy)",
    "Laparoscopic & Open Liver Resection & Parenchymal Transection Techniques",
    "Portosystemic Shunt Surgery (Portocaval, Mesocaval, Splenorenal) & Devascularisation",
    "Percutaneous, Laparoscopic & Open Liver Biopsy & Intraoperative Liver Ultrasound",
    "Drainage & Deroofing of Liver Abscesses, Hydatid Cysts & Hepatic Cysts",
  ],
  "Biliary, Gallbladder & Reconstructive Biliary Procedures": [
    "Radical / Extended Cholecystectomy with Hepatic Bed Resection & Nodal Dissection",
    "Resection & Reconstruction for Choledochal Cysts & Benign Biliary Strictures (Roux-en-Y Hepaticojejunostomy)",
    "Hilar Cholangiocarcinoma Resection (Klatskin Tumor Resection) & Biliary Reconstruction",
    "Transduodenal Resection of Ampulla of Vater & Duct Reconstruction",
  ],
  "Pancreatic, Duodenal & Transplant Surgery Procedures": [
    "Pancreatoduodenectomy (Whipple Procedure - Open & Laparoscopic)",
    "Distal Pancreatectomy (Spleen-Preserving & Radical with Regional Lymphadenectomy)",
    "Drainage & Reconstruction for Chronic Pancreatitis (Frey Procedure, Lateral Pancreaticojejunostomy, Pseudocyst Drainage)",
    "Enucleation & Resection of Pancreatic Neuroendocrine Tumours & Benign Cysts",
    "Living & Deceased Donor Hepatectomy, Organ Procurement, Preservation & Liver Transplantation",
  ],
};

export const HPB_SURGERY_CATEGORIES = Object.keys(HPB_SURGERY_PROCEDURES);

export const isMChInHPBSurgeryDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return (
    d.includes("hepato pancreato biliary") ||
    d.includes("hpb") ||
    d.includes("hepatobiliary")
  );
};
